import { Link, NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  ExternalLink,
  LayoutDashboard,
  LogOut,
  Package,
  Plus,
} from "lucide-react";
import { toast } from "sonner";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package, end: false },
  { to: "/admin/products/new", label: "Add Product", icon: Plus, end: false },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    toast.success("Logout berhasil");
    navigate("/admin/login", { replace: true });
  };

  return (
    <div
      data-testid="admin-layout"
      className="min-h-screen bg-[#050505] text-white"
    >
      <header className="border-b border-[#1f1f1f] bg-[#050505]/90 backdrop-blur-xl sticky top-0 z-30">
        <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
          <Link to="/admin" className="inline-flex items-baseline gap-2">
            <span className="font-display text-2xl uppercase text-white">
              ACE<span className="text-[#CCFF00]">.</span>
            </span>
            <span className="text-[10px] uppercase tracking-[0.25em] text-[#A3A3A3]">
              Admin
            </span>
          </Link>
          <div className="flex items-center gap-3">
            <a
              href="/"
              target="_blank"
              rel="noreferrer"
              data-testid="admin-view-site"
              className="hidden sm:inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#A3A3A3] hover:text-white border border-[#262626] px-3 py-2"
            >
              <ExternalLink className="w-3.5 h-3.5" />
              Lihat Website
            </a>
            <span className="hidden md:inline text-xs text-[#A3A3A3] truncate max-w-[180px]">
              {user?.email}
            </span>
            <button
              data-testid="admin-logout-btn"
              onClick={handleLogout}
              className="inline-flex items-center gap-2 bg-[#FF3B30] hover:bg-[#d8312a] text-white font-bold uppercase tracking-wider text-xs px-4 py-2 transition-colors"
            >
              <LogOut className="w-3.5 h-3.5" />
              Logout
            </button>
          </div>
        </div>
      </header>

      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 lg:px-8 py-8 grid md:grid-cols-[220px_1fr] gap-8">
        <aside className="md:sticky md:top-20 h-max">
          <p className="text-[10px] font-bold tracking-[0.3em] uppercase text-[#CCFF00] mb-3">
            Menu
          </p>
          <nav className="border border-[#262626] divide-y divide-[#262626]">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={`admin-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 text-sm font-bold uppercase tracking-wider transition-colors ${
                    isActive
                      ? "bg-[#CCFF00] text-black"
                      : "text-white hover:bg-[#0e0e0e]"
                  }`
                }
              >
                <item.icon className="w-4 h-4" />
                {item.label}
              </NavLink>
            ))}
          </nav>
        </aside>

        <main data-testid="admin-main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
